var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34356 2.37876V0L3.17188 3.17169L6.34356 6.34337V3.96461C8.96813 3.96461 11.1011 6.09756 11.1011 8.72213C11.1011 11.0771 9.38045 13.0277 7.13648 13.4083V15.01C10.2685 14.6215 12.6869 11.9573 12.6869 8.72213C12.6869 5.21742 9.84827 2.37876 6.34356 2.37876Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58584 8.72206C1.58584 7.41374 2.1171 6.22436 2.98138 5.36008L1.85544 4.23413C0.713629 5.38387 0 6.96971 0 8.72206C0 11.9572 2.41841 14.6214 5.55045 15.0099V13.4082C3.30648 13.0276 1.58584 11.077 1.58584 8.72206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminScheduleIcon);
export default __webpack_public_path__ + "static/media/AdminScheduleIcon.d055d21fb1f989279de5eb17a900f354.svg";
export { ForwardRef as ReactComponent };